import { get } from 'lodash';
import { adjustFormError } from '../../../../shared/utils/form.utils';

class FormError {
  constructor() {
    this.flattenedErrors = {
      errors: null,
      to: {}
    };
  }

  setFormErrors(errors) {
    this.flattenErrors(errors);
  }

  flattenErrors(errors) {
    let rootErrors = errors['errors'];
    let toProductsErrors = adjustFormError(get(errors, 'children.to.children'));

    this.flattenedErrors['errors'] = rootErrors;
    this.flattenedErrors['fromProduct'] = get(errors, 'children.from.errors');
    this.flattenedErrors['transactionPassword'] = get(errors, 'children.transactionPassword.errors');
    toProductsErrors.forEach((value, idx) => {
      let errors = value['children'];
      this.flattenedErrors.to[idx] = errors;
    });
  }

  getError(propertyPath) {
    return get(this.flattenedErrors, propertyPath);
  }

  get root() {
    return this.getError('errors');
  }

  get fromProduct() {
    return this.getError('fromProduct');
  }

  get transactionPassword() {
    return this.getError('transactionPassword');
  }

  to(path, key) {
    let propertyPath = `to.${key}.${path}.errors`;

    return this.getError(propertyPath);
  }
}

export default FormError;



// WEBPACK FOOTER //
// ./client/app/pages/customer/peertopeer/model/form-error.model.js